'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('./utils');

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AnimakitBase = function (_React$Component) {
  _inherits(AnimakitBase, _React$Component);

  function AnimakitBase() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AnimakitBase);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AnimakitBase.__proto__ || Object.getPrototypeOf(AnimakitBase)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      animation: false,
      winHeight: 0
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AnimakitBase, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.animationResetTO = null;
      this.resizeCheckerRAF = null;

      this.changingProps = [];
      this.useWinResize = false;

      this.init();

      this.listeners = this.getListeners();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.useWinResize) this.winResize();

      this.repaint(this.props);

      if (window && this.useWinResize) {
        window.addEventListener('resize', this.listeners.winResize, false);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.repaint(nextProps);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      var _this2 = this;

      var stateChanged = !utils.isEqual(nextState, this.state);

      var childrenChanged = !utils.isEqual(nextProps.children, this.props.children);

      var propsChanged = this.changingProps.some(function (name) {
        return nextProps[name] !== _this2.props[name];
      });

      return stateChanged || childrenChanged || propsChanged;
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      this.cancelResizeChecker();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.startResizeChecker();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.cancelResizeChecker();
      this.cancelAnimationReset();

      if (window && this.useWinResize) {
        window.removeEventListener('resize', this.listeners.winResize, false);
      }
    }
  }, {
    key: 'getListeners',
    value: function getListeners() {
      var listeners = {};

      listeners.checkResize = this.checkResize.bind(this);

      if (this.useWinResize) {
        listeners.winResize = this.winResize.bind(this);
      }

      return listeners;
    }
  }, {
    key: 'getDuration',
    value: function getDuration() {
      return this.props.duration;
    }
  }, {
    key: 'getScrollbarWidth',
    value: function getScrollbarWidth() {
      return utils.getScrollbarWidth();
    }
  }, {
    key: 'get3DSupport',
    value: function get3DSupport() {
      return utils.isPropertySupported('perspective', '1px') && utils.isPropertySupported('transform-style', 'preserve-3d');
    }
  }, {
    key: 'init',
    value: function init() {}
  }, {
    key: 'winResize',
    value: function winResize() {
      this.setState({
        winHeight: window ? window.innerHeight : 800
      });
    }
  }, {
    key: 'startResizeChecker',
    value: function startResizeChecker() {
      if (typeof requestAnimationFrame === 'undefined') return;
      this.resizeCheckerRAF = requestAnimationFrame(this.listeners.checkResize);
    }
  }, {
    key: 'cancelResizeChecker',
    value: function cancelResizeChecker() {
      if (typeof requestAnimationFrame === 'undefined') return;
      if (this.resizeCheckerRAF) cancelAnimationFrame(this.resizeCheckerRAF);
    }
  }, {
    key: 'startAnimationReset',
    value: function startAnimationReset() {
      var _this3 = this;

      this.animationResetTO = setTimeout(function () {
        _this3.setState({
          animation: false
        });
      }, this.getDuration());
    }
  }, {
    key: 'cancelAnimationReset',
    value: function cancelAnimationReset() {
      if (this.animationResetTO) clearTimeout(this.animationResetTO);
    }
  }, {
    key: 'checkResize',
    value: function checkResize() {
      this.cancelResizeChecker();

      if (this.softRepaint) {
        this.softRepaint();
      } else {
        this.repaint(this.props);
      }

      this.startResizeChecker();
    }
  }, {
    key: 'repaint',
    value: function repaint() /* nextProps */{
      var state = {};

      this.applyState(state);
    }
  }, {
    key: 'applyState',
    value: function applyState(state) {
      if (!Object.keys(state).length) return;

      if (state.animation) {
        this.cancelAnimationReset();
      }

      this.setState(state);

      if (state.animation) {
        this.startAnimationReset();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return false;
    }
  }]);

  return AnimakitBase;
}(_react2.default.Component);

AnimakitBase.propTypes = {
  children: _react2.default.PropTypes.any,
  duration: _react2.default.PropTypes.number
};
AnimakitBase.defaultProps = {
  duration: 500
};
exports.default = AnimakitBase;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/animakit-core/lib/AnimakitBase.js
// module id = 682
// module chunks = 0